// extracted by mini-css-extract-plugin
export default {"animate":"swipeImage_animate__LTsfC"};